export const headers = [
	'No.',
	'Filename',
	'Language',
	'Extension',
	'Mimetype',
	'Actions',
];
